export const MOCK_MENU_DATA = {
  "pizzas":

    [
      {
        "id": 1,
        "name": "Caffè",
        "description": "Espresso classico",
        "type": "CAFFETTERIA",
        "price": 1.30
      },
      {
        "id": 2,
        "name": "Caffè doppio",
        "description": "Doppio espresso classico",
        "type": "CAFFETTERIA",
        "price": 2.60
      },
      {
        "id": 3,
        "name": "Caffè DEK",
        "description": "Espresso decaffeinato",
        "type": "CAFFETTERIA",
        "price": 1.50
      },
      {
        "id": 4,
        "name": "Caffè macchiato soia",
        "description": "Espresso con latte di soia",
        "type": "CAFFETTERIA",
        "price": 1.50
      },
      {
        "id": 5,
        "name": "Cappuccino",
        "description": "Cappuccino classico",
        "type": "CAFFETTERIA",
        "price": 1.50
      },
      {
        "id": 6,
        "name": "Cappuccino di soia",
        "description": "Cappuccino con latte di soia",
        "type": "CAFFETTERIA",
        "price": 2.00
      },
      {
        "id": 7,
        "name": "Cappuccino DEK",
        "description": "Cappuccino decaffeinato",
        "type": "CAFFETTERIA",
        "price": 1.80
      },
      {
        "id": 8,
        "name": "Cappuccino DEK macchiato soia",
        "description": "Cappuccino decaffeinato con soia",
        "type": "CAFFETTERIA",
        "price": 2.00
      },
      {
        "id": 9,
        "name": "Ginseng",
        "description": "Disponibile piccolo (1,50€) o grande (2,00€)",
        "type": "CAFFETTERIA",
        "price": 1.50
      },
      {
        "id": 10,
        "name": "Orzo",
        "description": "Disponibile piccolo (1,50€) o grande (2,00€)",
        "type": "CAFFETTERIA",
        "price": 1.50
      },
      {
        "id": 11,
        "name": "Caffè americano",
        "description": "Espresso allungato con acqua calda",
        "type": "CAFFETTERIA",
        "price": 1.50
      },
      {
        "id": 12,
        "name": "Caffè leccese",
        "description": "Caffè con ghiaccio e latte di mandorla",
        "type": "CAFFETTERIA",
        "price": 2.50
      },
      {
        "id": 13,
        "name": "Caffè shakerato",
        "description": "Caffè agitato con ghiaccio",
        "type": "CAFFETTERIA",
        "price": 3.50
      },
      {
        "id": 14,
        "name": "Caffè shakerato DEK",
        "description": "Caffè decaffeinato agitato con ghiaccio",
        "type": "CAFFETTERIA",
        "price": 4.00
      },
      {
        "id": 15,
        "name": "Caffè shakerato corretto",
        "description": "Caffè shakerato con aggiunta di alcolico",
        "type": "CAFFETTERIA",
        "price": 4.50
      },
      {
        "id": 16,
        "name": "Cioccolata calda",
        "description": "Cioccolata in tazza",
        "type": "CAFFETTERIA",
        "price": 3.50
      },
      {
        "id": 17,
        "name": "Cioccolata calda con panna",
        "description": "Cioccolata in tazza con panna montata",
        "type": "CAFFETTERIA",
        "price": 4.00
      },
      {
        "id": 18,
        "name": "Bicerin analcolico",
        "description": "Bevanda tipica torinese (analcolica)",
        "type": "CAFFETTERIA",
        "price": 4.00
      },
      {
        "id": 19,
        "name": "Bicerin alcolico",
        "description": "Bevanda tipica torinese (alcolica)",
        "type": "CAFFETTERIA",
        "price": 4.50
      },
      {
        "id": 20,
        "name": "Marocchino",
        "description": "Caffè, cioccolato e schiuma di latte",
        "type": "CAFFETTERIA",
        "price": 2.50
      },
      {
        "id": 21,
        "name": "Marocchino con panna",
        "description": "Marocchino con panna montata",
        "type": "CAFFETTERIA",
        "price": 3.00
      },
      {
        "id": 22,
        "name": "Latte bianco",
        "description": "Bicchiere di latte caldo o freddo",
        "type": "CAFFETTERIA",
        "price": 1.50
      },
      {
        "id": 23,
        "name": "Latte bianco di soia",
        "description": "Bicchiere di latte di soia",
        "type": "CAFFETTERIA",
        "price": 2.00
      },
      {
        "id": 24,
        "name": "Latte macchiato",
        "description": "Latte caldo macchiato con caffè",
        "type": "CAFFETTERIA",
        "price": 3.00
      },
      {
        "id": 25,
        "name": "Latte macchiato di DEK",
        "description": "Latte macchiato con caffè decaffeinato",
        "type": "CAFFETTERIA",
        "price": 3.50
      },
      {
        "id": 26,
        "name": "Latte macchiato soia",
        "description": "Latte di soia macchiato con caffè",
        "type": "CAFFETTERIA",
        "price": 3.50
      },
      {
        "id": 27,
        "name": "The caldo",
        "description": "Infusi vari e the",
        "type": "CAFFETTERIA",
        "price": 2.50
      },
      {
        "id": 28,
        "name": "Latte con sciroppi",
        "description": "Latte aromatizzato con sciroppi",
        "type": "CAFFETTERIA",
        "price": 3.50
      },
      {
        "id": 29,
        "name": "Spremuta d’arancia",
        "description": "Spremuta fresca di stagione",
        "type": "CAFFETTERIA",
        "price": 4.00
      },
      {
        "id": 30,
        "name": "Succo di frutta",
        "description": "Vari gusti disponibili",
        "type": "BIBITE",
        "price": 3.00
      },
      {
        "id": 31,
        "name": "Estathè / Coca-cola / Fanta",
        "description": "Bibite in lattina o bottiglia",
        "type": "BIBITE",
        "price": 3.00
      },
      {
        "id": 32,
        "name": "Sprite / Lemonsoda / Acqua tonica",
        "description": "Bibite gassate",
        "type": "BIBITE",
        "price": 3.00
      },
      {
        "id": 33,
        "name": "Redbull",
        "description": "Energy drink",
        "type": "BIBITE",
        "price": 4.00
      },
      {
        "id": 34,
        "name": "Acqua naturale/frizzante",
        "description": "Bottiglia d'acqua 50cl",
        "type": "BIBITE",
        "price": 1.00
      },
      {
        "id": 35,
        "name": "TENNENTS",
        "description": "Birra chiara forte",
        "type": "BIRRE",
        "price": 4.50
      },
      {
        "id": 36,
        "name": "MORETTI",
        "description": "Birra lager italiana",
        "type": "BIRRE",
        "price": 3.50
      },
      {
        "id": 37,
        "name": "CORONA",
        "description": "Birra chiara messicana con lime",
        "type": "BIRRE",
        "price": 4.00
      },
      {
        "id": 38,
        "name": "CERES",
        "description": "Strong ale danese",
        "type": "BIRRE",
        "price": 4.00
      },
      {
        "id": 39,
        "name": "BECK'S",
        "description": "Birra pilsner tedesca",
        "type": "BIRRE",
        "price": 3.50
      },
      {
        "id": 40,
        "name": "HEINEKEN",
        "description": "Birra lager olandese",
        "type": "BIRRE",
        "price": 3.50
      },
      {
        "id": 41,
        "name": "ICHNUSA",
        "description": "Birra sarda",
        "type": "BIRRE",
        "price": 4.50
      },
      {
        "id": 42,
        "name": "MENABREA PICCOLA",
        "description": "Birra alla spina 20cl",
        "type": "BIRRE ALLA SPINA",
        "price": 3.50
      },
      {
        "id": 43,
        "name": "MENABREA MEDIA",
        "description": "Birra alla spina 40cl",
        "type": "BIRRE ALLA SPINA",
        "price": 5.00
      },
      {
        "id": 44,
        "name": "SPRITZ",
        "description": "Aperol / Campari / Hugo / Violetta",
        "type": "SPRITZ",
        "price": 5.00
      },
      {
        "id": 45,
        "name": "SPRITZ HUGO ST-GERMAIN",
        "description": "Spritz con liquore ai fiori di sambuco St-Germain",
        "type": "SPRITZ",
        "price": 8.00
      },
      {
        "id": 46,
        "name": "AMERICANO",
        "description": "Vermouth rosso, Campari, soda",
        "type": "COCKTAIL",
        "price": 7.00
      },
      {
        "id": 47,
        "name": "NEGRONI",
        "description": "Gin, Vermouth rosso, Campari",
        "type": "COCKTAIL",
        "price": 7.00
      },
      {
        "id": 48,
        "name": "NEGRONI SBAGLIATO",
        "description": "Prosecco, Vermouth rosso, Campari",
        "type": "COCKTAIL",
        "price": 7.00
      },
      {
        "id": 49,
        "name": "MOSCOW MULE",
        "description": "Vodka, Ginger beer, succo di lime",
        "type": "COCKTAIL",
        "price": 8.00
      },
      {
        "id": 50,
        "name": "VODKA LEMON",
        "description": "Vodka e lemonsoda",
        "type": "COCKTAIL",
        "price": 7.00
      },
      {
        "id": 51,
        "name": "LONG ISLAND",
        "description": "Vodka, Gin, Rum bianco, Triple sec, Tequila, Cola",
        "type": "COCKTAIL",
        "price": 8.00
      },
      {
        "id": 52,
        "name": "MOJITO",
        "description": "Rum bianco, zucchero di canna, lime, menta, soda",
        "type": "COCKTAIL",
        "price": 8.00
      },
      {
        "id": 53,
        "name": "MARGARITA",
        "description": "Tequila, Triple sec, succo di lime",
        "type": "COCKTAIL",
        "price": 8.00
      },
      {
        "id": 54,
        "name": "PINK LADY",
        "description": "Gin, granatina, succo di limone",
        "type": "COCKTAIL",
        "price": 8.00
      },
      {
        "id": 55,
        "name": "DAIQUIRI",
        "description": "Rum bianco, succo di lime, sciroppo di zucchero",
        "type": "COCKTAIL",
        "price": 8.00
      },
      {
        "id": 56,
        "name": "SEX ON THE BEACH",
        "description": "Vodka, liquore alla pesca, succo d'arancia, succo di cranberry",
        "type": "COCKTAIL",
        "price": 8.00
      },
      {
        "id": 57,
        "name": "CAIPIRINHA / CAIPIROSKA",
        "description": "Cachaca/Vodka, lime, zucchero di canna",
        "type": "COCKTAIL",
        "price": 8.00
      },
      {
        "id": 58,
        "name": "GIN TONIC/LEMON",
        "description": "Gin con tonica o lemon",
        "type": "COCKTAIL",
        "price": "da 7.00"
      },
      {
        "id": 59,
        "name": "Crodino",
        "description": "Analcolico biondo",
        "type": "ANALCOLICI",
        "price": 3.50
      },
      {
        "id": 60,
        "name": "Bitter bianco/rosso",
        "description": "Aperitivo analcolico classico",
        "type": "ANALCOLICI",
        "price": 3.50
      },
      {
        "id": 61,
        "name": "Cocktail analcolico della casa",
        "description": "Mix di frutta e bibite analcoliche",
        "type": "ANALCOLICI",
        "price": 6.00
      },
      {
        "id": 66,
        "name": "BAILEY’S",
        "description": "Crema di whisky irlandese",
        "type": "AMARI",
        "price": 3.50
      },
      {
        "id": 67,
        "name": "SAN SIMONE",
        "description": "Amaro d'erbe piemontese",
        "type": "AMARI",
        "price": 3.50
      },
      {
        "id": 68,
        "name": "AMARO DEL CAPO",
        "description": "Amaro alle erbe calabre (servito ghiacciato)",
        "type": "AMARI",
        "price": 3.50
      },
      {
        "id": 69,
        "name": "MONTENEGRO",
        "description": "Amaro classico italiano",
        "type": "AMARI",
        "price": 3.50
      },
      {
        "id": 70,
        "name": "FERNET BRANCA",
        "description": "Amaro amaro e rinfrescante",
        "type": "AMARI",
        "price": 3.50
      },
      {
        "id": 71,
        "name": "LIMONCELLO",
        "description": "Liquore ai limoni",
        "type": "AMARI",
        "price": 3.50
      },
      {
        "id": 72,
        "name": "Tagliere Piccolo",
        "description": "Selezione di salumi e formaggi (formato piccolo)",
        "type": "TAGLIERI",
        "price": 6.00
      },
      {
        "id": 73,
        "name": "Tagliere Grande",
        "description": "Selezione di salumi e formaggi (formato grande)",
        "type": "TAGLIERI",
        "price": 10.00
      },
      {
        "id": 74,
        "name": "INSALATA GRECA",
        "description": "feta greca, pomodorini, olive, cetrioli",
        "type": "INSALATE",
        "price": 9.00
      },
      {
        "id": 75,
        "name": "INSALATA TONNO",
        "description": "insalata, tonno, pomodorini, carote, olive",
        "type": "INSALATE",
        "price": 10.00
      },
      {
        "id": 76,
        "name": "CAPRESE",
        "description": "mozzarella di bufala, pomodorini, origano, basilico",
        "type": "INSALATE",
        "price": 7.50
      },
      {
        "id": 77,
        "name": "BRESAOLA",
        "description": "con rucola e scaglie di grana",
        "type": "INSALATE",
        "price": 8.00
      },
      {
        "id": 101,
        "name": "BIANCO (Calice / Bottiglia)",
        "description": "Vino bianco della casa",
        "type": "VINI BIANCHI",
        "price": "5 € / 25"
      },
      {
        "id": 102,
        "name": "TRAMINER (Calice / Bottiglia)",
        "description": "Vino bianco aromatico",
        "type": "VINI BIANCHI",
        "price": "5 € / 25"
      },
      {
        "id": 103,
        "name": "ARNEIS (Calice / Bottiglia)",
        "description": "Vino bianco tipico piemontese",
        "type": "VINI BIANCHI",
        "price": "5 € / 25"
      },
      {
        "id": 104,
        "name": "CHARDONNAY (Calice / Bottiglia)",
        "description": "Vino bianco internazionale",
        "type": "VINI BIANCHI",
        "price": "5 € / 25"
      },
      {
        "id": 105,
        "name": "RIBOLLA GIALLA (Calice / Bottiglia)",
        "description": "Vino bianco del Friuli",
        "type": "VINI BIANCHI",
        "price": "5 € / 25"
      },
      {
        "id": 106,
        "name": "PROSECCO (Calice / Bottiglia)",
        "description": "Bollicine italiane",
        "type": "VINI BIANCHI",
        "price": "5 € / 25"
      },
      {
        "id": 107,
        "name": "ROSATO (Calice / Bottiglia)",
        "description": "Vino rosato fresco",
        "type": "VINI BIANCHI",
        "price": "5 € / 25"
      },
      {
        "id": 108,
        "name": "BARBERA (Calice / Bottiglia)",
        "description": "Vino rosso piemontese",
        "type": "VINI ROSSI",
        "price": "6 € / 25"
      },
      {
        "id": 109,
        "name": "DOLCETTO (Calice / Bottiglia)",
        "description": "Vino rosso piemontese",
        "type": "VINI ROSSI",
        "price": "6 € / 29"
      },
      {
        "id": 110,
        "name": "NEBBIOLO (Calice / Bottiglia)",
        "description": "Vino rosso pregiato",
        "type": "VINI ROSSI",
        "price": "6 € / 25"
      },
      {
        "id": 111,
        "name": "RUCHÈ (Calice / Bottiglia)",
        "description": "Vino rosso aromatico piemontese",
        "type": "VINI ROSSI",
        "price": "7 € / 33"
      },
      {
        "id": 112,
        "name": "BAROLO (Calice / Bottiglia)",
        "description": "Il re dei vini rossi",
        "type": "VINI ROSSI",
        "price": "8 € / 35"
      },
      {
        "id": 113,
        "name": "BARBARESCO (Calice / Bottiglia)",
        "description": "Grande vino rosso da Nebbiolo",
        "type": "VINI ROSSI",
        "price": "8 € / 35"
      }
    ]
}
  ;